<template>
  <app-content class="regional-edit">
    <step-by-step
      :loading="loading"
      :steps="steps"
      :current-step.sync="step"
      :next-disabled="!canForward"
      :conclude-disabled="!saveEnabled"
      :conclude-button-text="$t('general.conclude')"
      @conclude="save()"
    >
      <regional-info
        slot="content:regional-info"
        :regional="regional"
        :valid.sync="firstStepValid"
        :loading.sync="loading"
      />

      <installations
        :regional="regional"
        slot="content:installations"
      />

      <template slot="bottomPreviousPanel">
        <b-button
          v-if="canCancel"
          class="regional-edit__cancel-button"
          variant="secondary"
          @click="cancel()"
        >
          {{ $t('general.cancel') }}
        </b-button>
      </template>
    </step-by-step>
  </app-content>
</template>

<script>
import StepByStep from '@/components/stepByStep/index';
import RegionalInfo from '@/domain/components/generalPanel/adminPanel/regional/editing/Info';
import Installations from '@/domain/components/generalPanel/adminPanel/regional/editing/Installations';
import RegionalEditService from '@/domain/services/generalPanel/adminPanel/regional/regionalEditService';

export default {
  components: {
    StepByStep,
    RegionalInfo,
    Installations,
  },
  data: () => ({
    regional: {
      installations: [],
    },
    loading: false,
    step: null,
    firstStepValid: false,
    steps: [
      {
        labelPath: 'regional-manager.editing.info.title',
        icon: 'fas fa-info-circle',
        name: 'regional-info',
      },
      {
        labelPath: 'regional-manager.editing.installations.title',
        icon: 'fas fa-broadcast-tower',
        name: 'installations',
      },
    ],
  }),
  computed: {
    canForward() {
      return this.firstStepValid;
    },
    saveEnabled() {
      return this.selectedInstallationIds.length;
    },
    canCancel() {
      return this.step === 0;
    },
    selectedInstallationIds() {
      return (this.regional.installations || [])
        .filter(it => it.selected)
        .map(it => it.id);
    },
  },
  created() {
    if (this.$route.params.regionalId) {
      this.getRegional(this.$route.params.regionalId);
    }
  },
  methods: {
    save() {
      const regional = {
        ...this.regional,
        installationsIds: this.selectedInstallationIds,
      };
      this.$confirmMessage({ code: 'MC011' })
        .accepted(() => {
          this.loading = true;
          RegionalEditService.saveRegional(regional)
            .then(() => {
              this.$pushAlert({ code: 'MS006' });
              this.$router.push({ name: 'admin-panel', params: { activeTabName: 'regional' } });
            })
            .finally(() => {
              this.loading = false;
            });
        });
    },
    cancel() {
      this.$confirmMessage({
        code: 'MC006',
      }).accepted(() => {
        this.$router.push({ name: 'admin-panel', params: { activeTabName: 'regional' } });
      });
    },
    getRegional(regionalId) {
      RegionalEditService
        .getRegional(regionalId).then((response) => {
          this.regional = response;
          this.$set(this.regional, 'installations', (this.regional.installations || []).map(it => ({
            ...it,
            selected: true,
          })));
          this.$set(this.regional, '$originalInstallations', this.regional.installations.slice());
          this.$set(this.regional, '$originalCompanyId', this.regional.companyId);
        });
    },
  },

};
</script>
